import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _taggedTemplateLiteral from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["displayAdult"];

var _templateObject;

import React from "react";
import { Flex } from "@catchoftheday/cg-components";
import { styled } from "@catchoftheday/theme";
import { jsx as ___EmotionJSX } from "@emotion/react";
var BlurWrapper = styled(Flex)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .adult-card {\n    pointer-events: ", ";\n    .adult-blur-box {\n      display: ", ";\n    }\n  }\n"])), function (props) {
  return props.displayAdult ? "auto" : "none";
}, function (props) {
  return props.displayAdult ? "none" : "flex";
});
export var AdultBlurWrapper = function AdultBlurWrapper(_ref) {
  var displayAdult = _ref.displayAdult,
      props = _objectWithoutProperties(_ref, _excluded);

  return ___EmotionJSX(BlurWrapper, _extends({
    displayAdult: displayAdult
  }, props));
};